import { StyleSheet } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  background: theme => ({
    backgroundColor: theme.colors.cardBackgroundColorThree,
    flex: 1,
  }),
  contentContainer: {
    minWidth: '100%',
    paddingHorizontal: '10%'
  },
  chart: {
    paddingTop: 0,
  },
  loader: theme => ({
    backgroundColor: theme.colors.cardBackgroundColorThree,
    paddingTop: 30,
  }),
  chartLoadingContainer: theme => ({
    marginTop: 56,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.cardBackgroundColor,
  }),
  chartErrorBackground: {
    backgroundColor: Colors.transparent,
    height: 177.8,
  },
  chartErrorIconStyle: {
    marginTop: 36,
    width: 40,
    height: 40,
  },
  chartErrorTextStyle: theme => ({
    color: theme.Colors.blackTwo,
    marginBottom: 18.4,
  }),
  chartErrorTryButtonContainerStyle: {
    marginTop: 0,
  },
});
